export const config = {
	HOST_SETTINGS: {
		current_host: "argo-archeology.ru",
		host_url: "https://argo-archeology.ru",
	},
}